// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { FormFilterName } from "../schema";

export function serialize_FormFilterName_internal(value: FormFilterName): unknown {
  return ((value: "CHANNEL" | "SOURCE" | "QUALITY" | "RATING" | "AUDIO" | "LANGUAGE" | "PUBLICATION_DATE" | "MIAB" | "EXPERT_PICK" | "VERIFAI_FORMAT_TYPE"): unknown => {
    return value;
  })(value);
}
export function serialize_FormFilterName(obj: FormFilterName): string {
  return renderJsonWithNumbersAsBigint(serialize_FormFilterName_internal(obj));
}
export function deserialize_FormFilterName_internal(value: unknown): ParserResult<FormFilterName> {
  return ((value: unknown): ParserResult<"CHANNEL" | "SOURCE" | "QUALITY" | "RATING" | "AUDIO" | "LANGUAGE" | "PUBLICATION_DATE" | "MIAB" | "EXPERT_PICK" | "VERIFAI_FORMAT_TYPE"> => {
    if (typeof value !== "string") {
      return { success: false, reason: `[#/components/schemas/FormFilterName]: '${value}' expected to be of type string.` };
    }
    switch (value) {
      case "CHANNEL":
        return { success: true, value: "CHANNEL" };
      case "SOURCE":
        return { success: true, value: "SOURCE" };
      case "QUALITY":
        return { success: true, value: "QUALITY" };
      case "RATING":
        return { success: true, value: "RATING" };
      case "AUDIO":
        return { success: true, value: "AUDIO" };
      case "LANGUAGE":
        return { success: true, value: "LANGUAGE" };
      case "PUBLICATION_DATE":
        return { success: true, value: "PUBLICATION_DATE" };
      case "MIAB":
        return { success: true, value: "MIAB" };
      case "EXPERT_PICK":
        return { success: true, value: "EXPERT_PICK" };
      case "VERIFAI_FORMAT_TYPE":
        return { success: true, value: "VERIFAI_FORMAT_TYPE" };
      default:
        return { success: false, reason: `[#/components/schemas/FormFilterName]: '${value}' expected to be enum, one of 'CHANNEL, SOURCE, QUALITY, RATING, AUDIO, LANGUAGE, PUBLICATION_DATE, MIAB, EXPERT_PICK, VERIFAI_FORMAT_TYPE'.` };
    }
  })(value);
}
export function deserialize_FormFilterName(str: string): ParserResult<FormFilterName> {
  return deserialize_FormFilterName_internal(parseJsonWithNumbersAsBigint(str));
}
